import axios from "axios";
import { useMutation } from "react-query";
import { Colleague } from "../../../../features/Connections/types/Colleague.type";
import { getOrgBackend } from "../../../../app/backend";

export const useRemoteFetchDepartmentUsers = () => {
  return useMutation({
    mutationFn: async (id: string) => {
      const response = await axios.get<Partial<Colleague>[]>(
        `${getOrgBackend()}/user-info/cost-center-units-users?costCenterUnitIds=${[id]}`
      );
      return response.data;
    }
  });
};
